import React from "react";
import * as S from "../styles";
import BottomContent from "./BottomContent";
import ButtonsContent from "./ButtonsContent";
import ShopContent from "./ShopContent";
import TelehealthContent from "./TelehealthContent";

var MenuContainer = function MenuContainer(_ref) {
  var e = _ref.values,
      t = _ref.drawerRef,
      n = _ref.setOpen,
      o = _ref.topLevelLinks,
      r = _ref.handleLinkClick,
      a = _ref.handleFilteredPipLinkClick,
      l = _ref.productCategories,
      i = _ref.loggedIn,
      s = _ref.isLoggingIn,
      c = _ref.accountLinks,
      m = _ref.learnCategories,
      u = _ref.forBusinessesCategories,
      C = _ref.onLogout,
      p = _ref.root,
      L = _ref.renderLinkAs,
      d = _ref.hasPartialPipLoad,
      h = _ref.membership,
      k = _ref.membershipLink,
      g = _ref.membershipSubText,
      R = _ref.onMenuCardClick,
      E = _ref.telehealthCategories,
      B = _ref.scheduleVirtualCareVisit;
  return React.createElement(S.MenuContainer, {
    style: e,
    ref: t,
    "data-testid": "mobile-menu-container"
  }, React.createElement(S.CloseButtonWrapper, {
    "data-testid": "mobile-menu-close-button",
    onClick: function onClick() {
      return n(!1);
    }
  }, React.createElement(S.CloseIcon, null)), React.createElement(S.MenuButtons, null, React.createElement(ButtonsContent, {
    topLevelLinks: o,
    accountLinks: c,
    loggedIn: i,
    isLoggingIn: s
  })), React.createElement(S.MenuBottom, null, React.createElement(TelehealthContent, {
    topLevelLinks: o,
    telehealthCategories: E,
    scheduleVirtualCareVisit: B,
    renderLinkAs: L,
    handleLinkClick: r,
    root: p
  })), React.createElement(S.Hr, null), React.createElement(S.MenuTop, null, React.createElement(ShopContent, {
    topLevelLinks: o,
    handleLinkClick: r,
    handleFilteredPipLinkClick: a,
    renderLinkAs: L,
    productCategories: l,
    setOpen: n,
    root: p,
    hasPartialPipLoad: d,
    onMenuCardClick: R
  })), React.createElement(S.Hr, null), React.createElement(S.MenuBottom, null, React.createElement(BottomContent, {
    topLevelLinks: o,
    accountLinks: c,
    learnCategories: m,
    renderLinkAs: L,
    loggedIn: i,
    forBusinessesCategories: u,
    membership: h,
    membershipLink: k,
    membershipSubText: g,
    onLogout: C
  })));
};

export default MenuContainer;